import { parseHashParams } from './params'

const PASSWORD_HASH = '158a323a7ba44870f23d96f1516dd70aa48e9a72db4ebb026b0a89e212a208ab'
const DATE_THRESHOLD = '20260701_104307'
const EXPIRE_DAYS = 15
const STORAGE_KEY = '__pwd_verified__'

function parseDateFromModelNum(modelNum) {
  const dateStr = modelNum.substring(0, 8)
  if (dateStr.length !== 8) return null
  const year = parseInt(dateStr.substring(0, 4), 10)
  const month = parseInt(dateStr.substring(4, 6), 10) - 1
  const day = parseInt(dateStr.substring(6, 8), 10)
  return new Date(year, month, day)
}

export function requiresPassword() {
  const params = parseHashParams()
  const modelNum = params.modelNum || ''
  if (!modelNum) return false

  if (modelNum < DATE_THRESHOLD) return true

  const modelDate = parseDateFromModelNum(modelNum)
  if (modelDate) {
    const now = new Date()
    const diffMs = now.getTime() - modelDate.getTime()
    const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24))
    if (diffDays > EXPIRE_DAYS) return true
  }

  return false
}

function sha256(message) {
  var K = [0x428a2f98, 0x71374491, 0xb5c0fbcf, 0xe9b5dba5, 0x3956c25b, 0x59f111f1, 0x923f82a4, 0xab1c5ed5, 0xd807aa98, 0x12835b01, 0x243185be, 0x550c7dc3, 0x72be5d74, 0x80deb1fe, 0x9bdc06a7, 0xc19bf174, 0xe49b69c1, 0xefbe4786, 0x0fc19dc6, 0x240ca1cc, 0x2de92c6f, 0x4a7484aa, 0x5cb0a9dc, 0x76f988da, 0x983e5152, 0xa831c66d, 0xb00327c8, 0xbf597fc7, 0xc6e00bf3, 0xd5a79147, 0x06ca6351, 0x14292967, 0x27b70a85, 0x2e1b2138, 0x4d2c6dfc, 0x53380d13, 0x650a7354, 0x766a0abb, 0x81c2c92e, 0x92722c85, 0xa2bfe8a1, 0xa81a664b, 0xc24b8b70, 0xc76c51a3, 0xd192e819, 0xd6990624, 0xf40e3585, 0x106aa070, 0x19a4c116, 0x1e376c08, 0x2748774c, 0x34b0bcb5, 0x391c0cb3, 0x4ed8aa4a, 0x5b9cca4f, 0x682e6ff3, 0x748f82ee, 0x78a5636f, 0x84c87814, 0x8cc70208, 0x90befffa, 0xa4506ceb, 0xbef9a3f7, 0xc67178f2]
  var H = [0x6a09e667, 0xbb67ae85, 0x3c6ef372, 0xa54ff53a, 0x510e527f, 0x9b05688c, 0x1f83d9ab, 0x5be0cd19]

  var msg = unescape(encodeURIComponent(message))
  var ml = msg.length
  var n = (ml + 8) >> 6; n = (n + 1) << 4
  var W = new Array(n)
  for (var i = 0; i < n; i++) W[i] = 0
  for (var i = 0; i < ml; i++) W[i >> 2] |= msg.charCodeAt(i) << (24 - (i & 3) * 8)
  W[i >> 2] |= 0x80 << (24 - (i & 3) * 8)
  W[n - 1] = ml * 8

  for (var b = 0; b < n; b += 16) {
    var w = W.slice(b, b + 16)
    for (var t = 16; t < 64; t++) {
      var s0 = ((w[t - 15] >>> 7) | (w[t - 15] << 25)) ^ ((w[t - 15] >>> 18) | (w[t - 15] << 14)) ^ (w[t - 15] >>> 3)
      var s1 = ((w[t - 2] >>> 17) | (w[t - 2] << 15)) ^ ((w[t - 2] >>> 19) | (w[t - 2] << 13)) ^ (w[t - 2] >>> 10)
      w[t] = (w[t - 16] + s0 + w[t - 7] + s1) | 0
    }
    var a = H[0], b_ = H[1], c = H[2], d = H[3], e = H[4], f = H[5], g = H[6], h = H[7]
    for (var t = 0; t < 64; t++) {
      var S1 = ((e >>> 6) | (e << 26)) ^ ((e >>> 11) | (e << 21)) ^ ((e >>> 25) | (e << 7))
      var ch = (e & f) ^ (~e & g)
      var T1 = (h + S1 + ch + K[t] + w[t]) | 0
      var S0 = ((a >>> 2) | (a << 30)) ^ ((a >>> 13) | (a << 19)) ^ ((a >>> 22) | (a << 10))
      var maj = (a & b_) ^ (a & c) ^ (b_ & c)
      var T2 = (S0 + maj) | 0
      h = g; g = f; f = e; e = (d + T1) | 0
      d = c; c = b_; b_ = a; a = (T1 + T2) | 0
    }
    H[0] = (H[0] + a) | 0; H[1] = (H[1] + b_) | 0; H[2] = (H[2] + c) | 0; H[3] = (H[3] + d) | 0
    H[4] = (H[4] + e) | 0; H[5] = (H[5] + f) | 0; H[6] = (H[6] + g) | 0; H[7] = (H[7] + h) | 0
  }

  var hex = ''
  for (var i = 0; i < 8; i++) hex += ((H[i] >>> 0).toString(16)).padStart(8, '0')
  return hex
}

export function verifyPassword(input) {
  return sha256(input) === PASSWORD_HASH
}

export function isPasswordVerified() {
  return sessionStorage.getItem(STORAGE_KEY) === '1'
}

export function markPasswordVerified() {
  sessionStorage.setItem(STORAGE_KEY, '1')
}

export function clearPasswordVerification() {
  sessionStorage.removeItem(STORAGE_KEY)
}
